/**
 * Created by Administrator on 2018/6/19.
 */
import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

import hf1 from '../store/hf1';
import webuser from '../store/modules/webuser';

export default new vuex.Store({
    modules: {
      hf1: hf1,
      webuser: webuser
    },



})



// WEBPACK FOOTER //
// ./src/store/index.js